export default {
  missingData: '--',
};
